import axios from "../../axios";

const urlNationality = "/master/nationalities";

const state = {
  nationalities: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
};

const actions = {
  async getListNationalities({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlNationality}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_NATIONALITIES", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_NATIONALITIES(state, data) {
    state.nationalities = data;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
